import { render, staticRenderFns } from "./single-exercise-library.vue?vue&type=template&id=42875c87&scoped=true"
import script from "./single-exercise-library.ts?vue&type=script&lang=ts&external"
export * from "./single-exercise-library.ts?vue&type=script&lang=ts&external"
import style0 from "./single-exercise-library.scss?vue&type=style&index=0&id=42875c87&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42875c87",
  null
  
)

export default component.exports